// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "small[data-v-6db9ab6e]{color:var(--stan-blue-5)}", "",{"version":3,"sources":["webpack://src/components/pages/InventoryForm.vue"],"names":[],"mappings":"AAAA,uBAAuB,wBAAwB","sourcesContent":["small[data-v-6db9ab6e]{color:var(--stan-blue-5)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
